import Component from 'inferno-component';
import { Grid, Statistic, Responsive, Segment } from 'semantic-ui-react';
import AnimationCount from 'react-count-animation';
import CoverHeader from '../cover/CoverHeader';

const numberOfUniversities = 11
const numberOfStudents = 133500
const numberOfDisplay = 49395
const traffic = 38500

export default class Statistics extends Component {
  render() {
    return (
      <Segment className='o-85'>
        <Grid divided='vertically' stackable>
          <Grid.Row centered columns={1}>
            <CoverHeader />
          </Grid.Row>
          <Grid.Row columns={4}>
            <Grid.Column textAlign='center'>
              <Statistic color='grey' size='small'>
                <Statistic.Value>
                  <Responsive maxWidth={Responsive.onlyTablet.maxWidth}>
                    {numberOfUniversities}
                  </Responsive>
                  <Responsive minWidth={Responsive.onlyComputer.minWidth}>
                    <AnimationCount
                      start={1}
                      count={numberOfUniversities}
                      duration={2000}
                      decimals={0}
                      useGroup={false}
                      animation='up'
                    />
                  </Responsive>
                </Statistic.Value>
                <Statistic.Label>Intézmény</Statistic.Label>
              </Statistic>
            </Grid.Column>
            <Grid.Column textAlign='center'>
              <Statistic color='grey' size='small'>
                <Statistic.Value>
                  <Responsive maxWidth={Responsive.onlyTablet.maxWidth}>
                    {numberOfStudents}
                  </Responsive>
                  <Responsive minWidth={Responsive.onlyComputer.minWidth}>
                    <AnimationCount
                      start={500}
                      count={numberOfStudents}
                      duration={2500}
                      decimals={0}
                      useGroup={false}
                      animation='up'
                    />
                  </Responsive>
                </Statistic.Value>
                <Statistic.Label> Hallgató elérése</Statistic.Label>
              </Statistic>
            </Grid.Column>
            <Grid.Column textAlign='center'>
              <Statistic color='grey' size='small'>
                <Statistic.Value>
                  <Responsive maxWidth={Responsive.onlyTablet.maxWidth}>
                    {numberOfDisplay}
                  </Responsive>
                  <Responsive minWidth={Responsive.onlyComputer.minWidth}>
                    <AnimationCount
                      start={1000}
                      count={numberOfDisplay}
                      duration={2500}
                      decimals={0}
                      useGroup={false}
                      animation='up'
                    />
                  </Responsive>
                </Statistic.Value>
                <Statistic.Label>Havi megjelenés reklámonként</Statistic.Label>
              </Statistic>
            </Grid.Column>
            <Grid.Column textAlign='center'>
              <Statistic color='grey' size='small'>
                <Statistic.Value>
                  <Responsive maxWidth={Responsive.onlyTablet.maxWidth}>
                    {traffic}
                  </Responsive>
                  <Responsive minWidth={Responsive.onlyComputer.minWidth}>
                    <AnimationCount
                      start={100}
                      count={traffic}
                      duration={2500}
                      decimals={0}
                      useGroup={false}
                      animation='up'
                    />
                  </Responsive>
                </Statistic.Value>
                <Statistic.Label>Intézmények összesített napi forgalma</Statistic.Label>
              </Statistic>
            </Grid.Column>
          </Grid.Row>
        </Grid>
    </Segment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/statistics/Statistics.js